import React from 'react';
import { config } from '../config';
import { useBootstrap, resetBootstrapOnLogout } from '../ui/BootstrapProvider';
import type { TenantBranding } from '../types/branding';

export type { TenantBranding } from '../types/branding';

export function resetBrandingOnLogout() {
  resetBootstrapOnLogout();
}

export function useBranding() {
  const { branding, loading, refreshBootstrap } = useBootstrap();

  // Tab title: tenant name when loaded; build-time default on login/unauthenticated pages.
  React.useEffect(() => {
    if (branding?.name) {
      document.title = branding.name;
    } else if (!loading) {
      document.title = config.brandName;
    }
  }, [branding?.name, loading]);

  const refresh = React.useCallback(() => {
    void refreshBootstrap();
  }, [refreshBootstrap]);

  return { branding, loading, refresh };
}
